import {AbstractAnimation} from '../animations/AbstractAnimation';

export abstract class AbstractEngine {

    protected animation:AbstractAnimation;

    constructor(animation:AbstractAnimation) {
        this.animation=animation;
    }

    public static getClassName():string {
        return 'AbstractEngine';
    }

    protected convertTime(time:string) {
        if (time.match(/(ms)$/)) return parseFloat(time);
        if (time.match(/(s)$/)) return parseFloat(time)*1000;
        assert(false);
    }

    public abstract play():AbstractAnimation;
    public abstract seek(pos:number):AbstractAnimation;
    public abstract scrub(pos:number):AbstractAnimation;

    static init() {
        if (!('animationEngines' in window)) (<any>window)['animationEngines']=[];
        let cn=this.getClassName();
        (<any>window)['animationEngines'][cn]=this;
    }

}

export {};